export const StripeConfig = {
	"perishable_key": process.env.REACT_APP_STRIPE_PUBLIC_KEY
}
